import { CACHE_TIME } from "@/lib/cacheConfig";
import { queryKeys } from "@/lib/queryKeys";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useQueryInvalidation } from "@/lib/queryInvalidation";
import {
  deleteBuyerBoss,
  getAllBuyerCodes,
  getBuyerBossList,
  getBuyerBossWithBuyerCode,
  updateBuyerBoss,
  type UpdateBuyerBossPayload,
} from "@/api/buyerBossService";

export const useGetBuyerBossList = () => {
  return useQuery({
    queryKey: queryKeys.masterBuyerBoss.list(),
    queryFn: () => getBuyerBossList(),
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useGetBuyerBossWithBuyerCode = () => {
  return useQuery({
    queryKey: queryKeys.masterBuyerBoss.withBuyerCode(),
    queryFn: () => getBuyerBossWithBuyerCode(),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useUpdateBuyerBoss = () => {
  const queryInvalidation = useQueryInvalidation();

  return useMutation({
    mutationFn: (payload: UpdateBuyerBossPayload) => updateBuyerBoss(payload),
    onSuccess: () => {
      queryInvalidation.invalidateBuyerBoss();
    },
  });
};

export const useDeleteBuyerBoss = () => {
  const queryInvalidation = useQueryInvalidation();

  return useMutation({
    mutationFn: (employee_id: string) => deleteBuyerBoss(employee_id),
    onSuccess: () => {
      queryInvalidation.invalidateBuyerBoss();
    },
  });
};

export const useGetAllBuyerCodes = () => {
  return useQuery({
    queryKey: queryKeys.masterBuyerBoss.allBuyerCodes(),
    queryFn: () => getAllBuyerCodes(),
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};
